/*eslint no-console: "off"*/
/*eslint no-fallthrough: "off"*/
const logger = {};

function getLogLevel() {
    if (document.location.host.indexOf("wandern-andreasberge") > -1) {
        return "WARN";
    }
    return "DEBUG";
}

if (!window.console) {
    logger.debug = function(){};
    logger.info = function(){};
    logger.warn = function(){};
    logger.error = function(){};
} else {

    const logPrefix = "StA - ";

    logger.debug = function(msg, obj) {
        if (typeof obj == 'undefined') {
            console.log(logPrefix + "DEBUG ", msg);
        } else {
            console.log(logPrefix + "DEBUG ", msg, obj);
        }
    };
    logger.info = function(msg, obj) {
        if (typeof obj == 'undefined') {
            console.info(logPrefix + "INFO ", msg);
        } else {
            console.info(logPrefix + "INFO ", msg, obj);
        }
    };
    logger.warn = function(msg, obj) {
        if (typeof obj == 'undefined') {
            console.warn(logPrefix + "WARN ",  msg);
        } else {
            console.warn(logPrefix + "WARN ",  msg, obj);
        }
    };
    logger.error = function(msg,obj) {
        if (typeof obj == 'undefined') {
            console.error(logPrefix + "ERROR ", msg);
        } else {
            console.error(logPrefix + "ERROR ", msg, obj);
        }
    };

    let logLevel =  getLogLevel();
    
    switch (logLevel) {
    case "ERROR":
        logger.warn = function(){};
    case "WARN":
        logger.info = function(){};
    case "INFO":
        logger.debug = function(){};
    }
}
export default logger;
